import { Reducer } from "redux"
import { InstrumentLoginActionTypes, InstrumentLoginApiState } from "./instrument-login-api-types"
import { DEFAULT_INSTRUMENT_LOGIN_CONFIG } from "../../model/instrument-login-model"

const initialState: InstrumentLoginApiState = {
    loadingUsers: false,
    users: [],
    loadingUsersError: null,

    loadingCurrentUserInfo: false,
    currentUserInfo: null,
    loadingCurrentUserInfoError: null,

    postingCredentials: false,
    postingCredentialsError: null,

    unlockingUser: false,
    unlockingUserError: null,

    forcingExpire: false,
    forcingExpireError: null,

    deletingUser: false,
    deletingUserError: null,

    loadingConfig: false,
    config: DEFAULT_INSTRUMENT_LOGIN_CONFIG,
    loadingConfigError: null,
    savingConfig: false,
    savingConfigError: null,

    loadingInstruments: false,
    instruments: [],
    instrumentConnections: [],
    loadingInstrumentsError: null
}

export const instrumentLoginReducer: Reducer<InstrumentLoginApiState> = (
    state: InstrumentLoginApiState = initialState,
    action: any
): InstrumentLoginApiState => {
    switch (action.type) {
        case InstrumentLoginActionTypes.GET_INSTRUMENT_USERS_ATTEMPT:
            return Object.assign({}, state, {
                loadingUsers: true,
                loadingUsersError: null
            })

        case InstrumentLoginActionTypes.GET_INSTRUMENT_USERS_SUCCESS:
            return Object.assign({}, state, {
                loadingUsers: false,
                users: action.payload
            })

        case InstrumentLoginActionTypes.GET_INSTRUMENT_USERS_FAILURE:
            return Object.assign({}, state, {
                loadingUsers: false,
                loadingUsersError: action.payload
            })

        case InstrumentLoginActionTypes.GET_CURRENT_USER_INFO_ATTEMPT:
            return Object.assign({}, state, {
                loadingCurrentUserInfo: true,
                loadingCurrentUserInfoError: null
            })

        case InstrumentLoginActionTypes.GET_CURRENT_USER_INFO_SUCCESS:
            return Object.assign({}, state, {
                loadingCurrentUserInfo: false,
                currentUserInfo: action.payload
            })

        case InstrumentLoginActionTypes.GET_CURRENT_USER_INFO_FAILURE:
            return Object.assign({}, state, {
                loadingCurrentUserInfo: false,
                loadingCurrentUserInfoError: action.payload
            })

        case InstrumentLoginActionTypes.POST_CREDENTIALS_ATTEMPT:
            return Object.assign({}, state, {
                postingCredentials: true,
                postingCredentialsError: null
            })

        case InstrumentLoginActionTypes.POST_CREDENTIALS_SUCCESS:
            return Object.assign({}, state, {
                postingCredentials: false,
                currentUserInfo: action.payload
            })

        case InstrumentLoginActionTypes.POST_CREDENTIALS_FAILURE:
            return Object.assign({}, state, {
                postingCredentials: false,
                postingCredentialsError: action.payload
            })

        case InstrumentLoginActionTypes.POST_CREDENTIALS_CLEAR_ERROR:
            return Object.assign({}, state, {
                postingCredentialsError: null
            })

        case InstrumentLoginActionTypes.UNLOCK_USER_ATTEMPT:
            return Object.assign({}, state, {
                unlockingUser: true,
                unlockingUserError: null
            })

        case InstrumentLoginActionTypes.UNLOCK_USER_SUCCESS:
            return Object.assign({}, state, {
                unlockingUser: false
            })

        case InstrumentLoginActionTypes.UNLOCK_USER_FAILURE:
            return Object.assign({}, state, {
                unlockingUser: false,
                unlockingUserError: action.payload
            })

        case InstrumentLoginActionTypes.FORCE_EXPIRE_PASSWORD_ATTEMPT:
            return Object.assign({}, state, {
                forcingExpire: true,
                forcingExpireError: null
            })

        case InstrumentLoginActionTypes.FORCE_EXPIRE_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                forcingExpire: false
            })

        case InstrumentLoginActionTypes.FORCE_EXPIRE_PASSWORD_FAILURE:
            return Object.assign({}, state, {
                forcingExpire: false,
                forcingExpireError: action.payload
            })

        case InstrumentLoginActionTypes.DELETE_USER_ATTEMPT:
            return Object.assign({}, state, {
                deletingUser: true,
                deletingUserError: null
            })

        case InstrumentLoginActionTypes.DELETE_USER_SUCCESS:
            return Object.assign({}, state, {
                deletingUser: false
            })

        case InstrumentLoginActionTypes.DELETE_USER_FAILURE:
            return Object.assign({}, state, {
                deletingUser: false,
                deletingUserError: action.payload
            })

        case InstrumentLoginActionTypes.GET_CONFIG_ATTEMPT:
            return Object.assign({}, state, {
                loadingConfig: true,
                loadingConfigError: null
            })

        case InstrumentLoginActionTypes.GET_CONFIG_SUCCESS:
            return Object.assign({}, state, {
                loadingConfig: false,
                config: action.payload || DEFAULT_INSTRUMENT_LOGIN_CONFIG
            })

        case InstrumentLoginActionTypes.GET_CONFIG_FAILURE:
            return Object.assign({}, state, {
                loadingConfig: false,
                loadingConfigError: action.payload
            })

        case InstrumentLoginActionTypes.SAVE_CONFIG_ATTEMPT:
            return Object.assign({}, state, {
                savingConfig: true,
                savingConfigError: null
            })

        case InstrumentLoginActionTypes.SAVE_CONFIG_SUCCESS:
            return Object.assign({}, state, {
                savingConfig: false,
                config: action.payload || DEFAULT_INSTRUMENT_LOGIN_CONFIG
            })

        case InstrumentLoginActionTypes.SAVE_CONFIG_FAILURE:
            return Object.assign({}, state, {
                savingConfig: false,
                savingConfigError: action.payload
            })

        case InstrumentLoginActionTypes.GET_INSTRUMENTS_ATTEMPT:
            return Object.assign({}, state, {
                loadingInstruments: true,
                loadingInstrumentsError: null
            })

        case InstrumentLoginActionTypes.GET_INSTRUMENTS_SUCCESS:
            return Object.assign({}, state, {
                loadingInstruments: false,
                instruments: action.payload.instruments,
                instrumentConnections: action.payload.connections
            })

        case InstrumentLoginActionTypes.GET_INSTRUMENTS_FAILURE:
            return Object.assign({}, state, {
                loadingInstruments: false,
                loadingInstrumentsError: action.payload
            })

        default:
            return state
    }
}
